import { Block } from "baseui/block";
import { Button, SHAPE, SIZE } from "baseui/button";
import { LabelSmall, ParagraphXSmall } from "baseui/typography";
import { useState } from "react";
import { VscEdit, VscTrash } from "react-icons/vsc";
import { FormattedMessage, useIntl } from "react-intl";
import { is0oClock, isWholeDayTimeRange } from "../../../../utils/timeUtils";
import { EditEventDialog } from "../EditEventValueDialog/EditEventDialog";
import { IScheduler } from "../types";
import { getPrettifiedValueString, getValueOptions } from "../utils";

function DefaultItemContent(props: {eventInfo: any, app: IScheduler, onDeleteEvent: (event: any) => void, onValueChanged: any, disabled?: boolean}) {
    const { eventInfo, app, onDeleteEvent,onValueChanged } = props;
    const event = eventInfo.event;
    const start = event.start;
    const end = event.end;
    const intl = useIntl();
    const isWholeDay = isWholeDayTimeRange(start, end) && is0oClock(start);

    const valueOptions = getValueOptions(props.app);
    
    return (
      <>
      <Block display='flex' flexDirection='column' marginLeft='5px' gridGap='10px'>
        <Block display='flex' flexDirection='row' justifyContent='space-between'>
          {!isWholeDay && <ParagraphXSmall margin={0}>{eventInfo.timeText}</ParagraphXSmall>}
          {isWholeDay && <ParagraphXSmall margin={0}><FormattedMessage id="Scheduler.AllDay" defaultMessage="All Day" /></ParagraphXSmall>}
          <Button disabled={props.disabled} kind='tertiary' size={SIZE.mini} shape={SHAPE.round} onClick={() => onDeleteEvent(eventInfo.event)}><VscTrash /></Button>
        </Block>
        <Block display='flex' flexDirection='row' justifyContent='space-between'>
          <LabelSmall>{getPrettifiedValueString(app.dataType, eventInfo.event.title, app.stateTextList, intl)}</LabelSmall>
          <EditEvent valueOptions={valueOptions} app={props.app} disabled={props.disabled} eventId={eventInfo.event.id} dataType={app.dataType} timeFrom={eventInfo.event.start} timeTo={eventInfo.event.end} onAccept={onValueChanged} value={event.title}></EditEvent>
        </Block>
      </Block>
      </>
    )
  }

  export default DefaultItemContent;

const EditEvent = (props: any) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
      <>
        <Button disabled={props.disabled} onClick={() => setIsOpen(true)} kind='tertiary' size={SIZE.mini} shape={SHAPE.round}><VscEdit /></Button>
        <EditEventDialog valueOptions={props.valueOptions} timeFrom={props.timeFrom} timeTo={props.timeTo} eventId={props.eventId} dataType={props.dataType} onAccept={props.onAccept} isOpen={isOpen} setIsOpen={setIsOpen} value={props.value} />
      </>
    )
  };